import React, { ComponentProps, PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import Animated, { FadeIn } from 'react-native-reanimated';

import { Main } from '@expo/html-elements';

import { theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const HomeContainer = (props: ComponentProps<typeof ScrollView>) => {
  return (
    <ScrollView contentContainerStyle={styles.flexGrow} {...props}>
      {props.children}
    </ScrollView>
  );
};

const HomeContainerContent = (props: PropsWithChildren) => {
  const { match } = useResponsive();

  return <Main style={match([styles.containerXS, styles.containerSM])}>{props.children}</Main>;
};

const HomeContainerAnimatedContent = (props: PropsWithChildren) => {
  const { match } = useResponsive();

  return (
    <Animated.View
      style={match([styles.containerXS, styles.containerSM])}
      entering={FadeIn.duration(ANIMATION_DURATION)}
    >
      {props.children}
    </Animated.View>
  );
};

HomeContainer.Content = HomeContainerContent;
HomeContainer.AnimatedContent = HomeContainerAnimatedContent;

// ─── Constants ───────────────────────────────────────────────────────────────

const ANIMATION_DURATION = 500;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  flexGrow: {
    flexGrow: 1,
  },
  containerXS: {
    flexGrow: 1,
    gap: theme.spacing['4'],
  },
  containerSM: {
    gap: theme.spacing['10'],
  },
});
